import { NOTIFICATIONS_UNREAD_COUNT_QUERY_KEY } from "@frontend-shared/constants";
import { useQuery } from "@tanstack/react-query";

import { notificationsApi } from "@/api/services";

export const unreadCountQueryKey = () => [NOTIFICATIONS_UNREAD_COUNT_QUERY_KEY];

interface IUseUnreadCountProps {
  enabled?: boolean;
}

export const useUnreadCount = ({ enabled = true }: IUseUnreadCountProps = {}) =>
  useQuery({
    queryKey: unreadCountQueryKey(),
    queryFn: () => notificationsApi.getUnreadCount(),
    enabled,
  });
